import Collapse from '@material-ui/core/Collapse';
import IconButton from '@material-ui/core/IconButton';
// https://material-ui.com/components/alert/#description
import { makeStyles } from '@material-ui/core/styles';
import CloseIcon from '@material-ui/icons/Close';
import { Alert, AlertTitle } from '@material-ui/lab';
import React, { useState } from 'react';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    '& > * + *': {
      marginTop: theme.spacing(2),
    },
  },
}));

function CustomAlert(props) {
  const classes = useStyles();
  const [open, setOpen] = useState(true);

  return (
    <div className={classes.root}>
      <Collapse in={open}>
        <Alert
          severity={props.variant}
          action={
            <IconButton
              aria-label="close"
              color="inherit"
              size="small"
              onClick={() => {
                setOpen(false);
              }}
            >
              <CloseIcon fontSize="inherit" />
            </IconButton>
          }
        >
          {props.heading ? <AlertTitle>{props.heading}</AlertTitle> : ''}
          {props.message}
          {props.children}
        </Alert>
      </Collapse>
    </div>
  );
}

export default CustomAlert;
